import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-39ccf32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_cards account_fields" }
const _hoisted_2 = { class: "title_box with_card_order" }
const _hoisted_3 = {
  key: 0,
  class: "card-box"
}
const _hoisted_4 = { class: "my_card_infobox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card_number_box" })
], -1))
const _hoisted_6 = { class: "right_side" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "card-box"
}
const _hoisted_9 = { class: "my_card_infobox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card_number_box" })
], -1))
const _hoisted_11 = { class: "right_side" }
const _hoisted_12 = { class: "block_card_box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button_main = _resolveComponent("ui-button-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$localization.getTranslate("MyCards")), 1)
      ]),
      (!_ctx.cardsEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ui_button_main, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Coming soon.. ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.Cards.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_ui_button_main, {
                          isArrow: "",
                          onOnClick: _ctx.OrderCard
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("OrderCard")), 1)
                          ]),
                          _: 1
                        }, 8, ["onOnClick"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}